<template>
	<div>
		<AmeliproHeader
			v-if="!$maintenanceEnabled"
			:key="headerKey"
			:amelipro-header-infos="headerInfo"
			sub-menu
			:unlogged="isUnlogged"
			:no-right-part="isUnlogged"
			:no-sub-part="isUnlogged"
			:sub-menu-items="navigationItems"
			:home-href="urlApp"
			:amelipro-href="urlAmeliPro"
			:service-name="pageTitle"
		>
			<template #userMenu>
				<UserMenu
					:last-connexion="
						utilisateurExterneInfo.dateDerniereConnexion | formatDateTime
					"
					@click:logout="handleLogoutClick"
					@click:account="handleMesInformationsClick"
				>
					<template #default="">
						<ProfilDefault :utilisateur-externe-info="utilisateurExterneInfo" />
					</template>
					<template #complementaryInfo="">
						<ProfilComplementary
							:utilisateur-externe-info="utilisateurExterneInfo"
						/>
					</template>
				</UserMenu>
			</template>
		</AmeliproHeader>
	</div>
</template>

<script lang="ts">
	import Component, { mixins } from 'vue-class-component';
	import UserMixin from '@/mixins/userMixin';
	const MixinsDeclaration = mixins(UserMixin);
	import ProfilComplementary from '@/views/Profil/ProfilComplementary.vue';
	import ProfilDefault from '@/views/Profil/ProfilDefault.vue';
	import { UserInformationSummaryInfos } from '@/services/api/types';

	@Component<AppHeader>({
		components: {
			ProfilComplementary,
			ProfilDefault
		},
		data() {
			return {
				urlApp: process.env.VUE_APP_URL,
				urlAmeliPro: process.env.VUE_APP_AMELIEPRO_URL
			};
		},
		methods: {
			handleLogoutClick() {
				if (this.$route.path != '/logout') {
					this.$router.push('/logout');
				}
			},
			handleMesInformationsClick() {
				if (this.$route.path != '/utilisateurExterne/infos') {
					this.$router.push('/utilisateurExterne/infos');
				}
			}
		},
		watch: {
			$route() {
				this.updateTitle();
			},
			isUnlogged() {
				// Hack Met à jour la clé pour forcer la mise à jour du composant
				this.headerKey++;
			}
		},
		mounted() {
			this.updateTitle();
		},
		computed: {
			isUnlogged(): boolean {
				return !this.loggedIn;
			},
			headerInfo() {
				// Utilise le mixin pour accéder à utilisateurExterneInfo
				const utilisateurExterneInfo = this.utilisateurExterneInfo;

				const userInformationSummaryInfos: UserInformationSummaryInfos = {
					denomination: '',
					categorieSpecialite: '',
					userName: ''
				};
				// Récupération des données pour chaque profil
				if (Object.keys(utilisateurExterneInfo).length > 0) {
					userInformationSummaryInfos.userName =
						utilisateurExterneInfo.denominationComplet;
					if (
						utilisateurExterneInfo.isDocteur &&
						utilisateurExterneInfo.executant &&
						utilisateurExterneInfo.executant.rpps
					) {
						userInformationSummaryInfos.denomination =
							'N° RPPS : ' + utilisateurExterneInfo.executant.rpps;
						userInformationSummaryInfos.categorieSpecialite =
							utilisateurExterneInfo.executant.categorieLibelle;
					} else if (
						utilisateurExterneInfo.isStructure &&
						utilisateurExterneInfo.numAm
					) {
						userInformationSummaryInfos.denomination =
							'N° AM : ' + utilisateurExterneInfo.numAm;
						userInformationSummaryInfos.categorieSpecialite =
							utilisateurExterneInfo.executant
								? utilisateurExterneInfo.executant.categorieLibelle
								: '';
					} else if (
						utilisateurExterneInfo.isDelegataire &&
						utilisateurExterneInfo.delegataire.numeroPrint
					) {
						userInformationSummaryInfos.denomination =
							utilisateurExterneInfo.delegataire.numeroPrint;
						userInformationSummaryInfos.categorieSpecialite = 'Mandataire';
					}

					this.loadMenuItems();
				}

				return {
					headerTitle: 'PEGASE',
					userInformationSummaryInfos
				};
			}
		}
	})
	export default class AppHeader extends MixinsDeclaration {
		pageTitle = '';
		headerKey = 0;
		userInfoLoaded = false;

		updateTitle(): void {
			this.pageTitle = window.document.title;
		}

		loadMenuItems(): void {
			if (!this.userInfoLoaded) {
				this.setupNavigationItem();
				this.userInfoLoaded = true;
			}
		}

		setupNavigationItem(): void {
			this.navigationItems.push(
				{
					id: 1,
					name: 'Demande de paiement (DPA)',
					to: '/gardes/dpa'
				},
				{
					id: 2,
					name: 'Recherche de gardes',
					to: '/gardes/recherche'
				},
				{
					id: 3,
					name: 'Historique des gardes validées',
					to: '/dpa/historique'
				},
				{
					id: 4,
					name: 'Mon compte / Mes contacts',
					to: '/utilisateurExterne/infos'
				},
				{
					id: 7,
					name: 'Déconnexion',
					to: '/logout'
				}
			);

			if (
				this.utilisateurExterneInfo &&
				this.utilisateurExterneInfo.isAutoriseLoginMdpAccess
			) {
				// Insertion avant déconnexion
				this.navigationItems.splice(this.navigationItems.length - 1, 0, {
					id: 6,
					name: 'Modification du mot de passe',
					to: '/update-password'
				});
			}
		}

		navigationItems: { id: number; name: string; to: string }[] = [];
	}
</script>
